import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import { StyledText } from '../../../../components/StyledText';
import { InvestorItem } from './InvestorItem';
import { ConnectorDealReferral, MatchListType } from '../../../../types/types';
import { useConnectorDeals } from '../../../../contexts';

const useStyles = makeStyles(() => ({
  root: {
    margin: 0
  },
  investorItemRoot: {
    width: '100%',
    marginTop: '20px',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center'
  },
  seeAll: {
    cursor: 'pointer'
  },
  flexDiv: {
    display: 'flex'
  },
  listContainer: {
    display: 'flex',
    alignItems: 'baseline',
    marginTop: '8px'
  }
}));


export interface DoneDealInvestorsPanelProps {
  investorsList: Array<ConnectorDealReferral>;
  entProfileId: number;
}

export const DoneDealInvestorsPanel: React.FC<DoneDealInvestorsPanelProps> = ({
  investorsList = new Array<ConnectorDealReferral>(),
  entProfileId
}) => {
  const styles = useStyles();
  const history = useHistory();
  const { goToInvestorProfile } = useConnectorDeals();
  const maxInvestorsCount = 3;
  const investorsToShow = investorsList.slice(0, Math.min(maxInvestorsCount, investorsList.length));
  const remainingInvestorsCount = investorsList.length - investorsToShow.length;
  return (
    <Grid container justify='space-between' className={styles.root} spacing={1}>
      <Grid item xs={12}>
        <div className={styles.flexDiv}>
          <StyledText variant='h3' component='div'>
            Sent Referrals &nbsp;
          </StyledText>
          <StyledText variant='counter' color='primary'>
            {investorsList.length}
          </StyledText>
        </div>
        {investorsToShow.map((it: ConnectorDealReferral, index: number) =>
          (<InvestorItem key={index} profileImage={it.profileImage} contactName={it.contactName} companyName={it.companyName} status={it.status} showStatus goToProfile={() => { goToInvestorProfile(it.investorProfileId); }} />))}
        {investorsList.length > 0 && (
        <div className={styles.listContainer}>
          {remainingInvestorsCount !== 0 && (
            <StyledText variant='body1' component='div' color='textSecondary'>
              {`and ${remainingInvestorsCount} other investor` + (remainingInvestorsCount > 1 ? 's' : '')}
              {' '}
              &nbsp;
            </StyledText>
          )}
          {investorsList.length > 3 && (
          <StyledText variant='link' color='secondary' className={styles.seeAll} onClick={() => history.push(`/entrepreneur/${entProfileId}/matched-investors/sent`)}>
            See all &gt;
          </StyledText>
          )}
        </div>
        )}
      </Grid>
    </Grid>
  );
};
